<template>
  <span>
    <seminar-entry-detail-resume
      :entry-id="entryId"
    />
    <div class="pega-flex-center">
      <button
        class="boss-button boss-button-fill display-inline-flex"
        data-test="remove-button"
        @click="doRemove"
      >この応募者情報を削除する（復活不可）</button>
    </div>
  </span>
</template>

<script>
import SeminarEntryDetailResume from '@/components/organisms/SeminarEntryDetailResume'

export default {
  components: {
    SeminarEntryDetailResume
  },
  props: {
    entryId: {
      type: Number,
      required: true
    }
  },
  methods: {
    removeEntry () {
      return this.$http.secured.put(`/seminar/entries/${this.entryId}/_closed`)
    },
    doRemove () {
      this.$dialog.confirm('削除しますか？')
        // はいを押下した時
        .then(() => {
          this.removeEntry()
            .then(() => {
              this.$toasted.global.success({ message: 'セミナー応募者情報を削除しました。' })
              this.$router.push({ name: 'seminarEntryTop' })
            })
        })
        // いいえを押下した時（catch句を消すとコンソールに警告が出るから消さないでね！！）
        .catch(() => {})
    }
  }
}
</script>
